import { connect } from "react-redux";
import UCDCasesEdit from "./CaseEdit";
import { bindActionCreators } from "redux";
import {documentUploadUrlPublic} from 'services/redux/fileUpload/action';
import {
    carBrandRequest,
    carModelRequest,
    carVariantRequest,
    bankListRequest,
    loanApplicationByIdRequest,
    loanApplicationUpdateRequest,
    loanAccountRequest,
    newBankDetailsRequest,
    vehicleDetailsRequest
} from "../../../../../services/redux/CarLoan/action";
const mapStateToProps = (state) => ({
    carBrandResponse : state.CarLoan.carBrandResponse,
    carModelResponse : state.CarLoan.carModelResponse,
    carVariantResponse : state.CarLoan.carVariantResponse,
    bankListResponse : state.CarLoan.bankListResponse,
    ucdCaseByIdResponse : state.CarLoan.loanApplicationByIdResponse,
    loanApplicationUpdateResponse : state.CarLoan.loanApplicationUpdateResponse,
    loanAccountResponse : state.CarLoan.loanAccountResponse,
    newBankDetailsResponse : state.CarLoan.newBankDetailsResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    vehicleDetailsResponse : state.CarLoan.vehicleDetailsResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        documentUploadUrlPublic,
        carBrandRequest,
        carModelRequest,
        carVariantRequest,
        bankListRequest,
        loanApplicationByIdRequest,
        loanApplicationUpdateRequest,
        loanAccountRequest,
        newBankDetailsRequest,
        vehicleDetailsRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UCDCasesEdit);